module.exports = __webpack_public_path__ + "static/media/gmr_ground_hover.19bb7385.svg";